import React, {useEffect, useRef} from "react";
import "./Disclaimer.scss";
import {Anchor, Col, Row} from "antd";

const Disclaimer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const ansWrapperRef = React.useRef(null);
  return (
    <div className="disclaimerContainer">
      <div className="disclaimerWrapper">
        <h1 className="disclaimerTitle">Disclaimer</h1>
        <p className="lastUpdated">Last updated December 21, 2021</p>

        <Row className="disclaimerOptionsSection">
          <Col className="disclaimerTypes">
            <Anchor
              affix={false}
              getContainer={() => ansWrapperRef.current}
              items={[
                {
                  key: "part-1",
                  href: "#part-1",
                  title: "WEBSITE DISCLAIMER",
                },
                {
                  key: "part-2",
                  href: "#part-2",
                  title: "EXTERNAL LINKS DISCLAIMER",
                },
                {
                  key: "part-3",
                  href: "#part-3",
                  title: "PROFESSIONAL DISCLAIMER",
                },
                {
                  key: "part-4",
                  href: "#part-4",
                  title: "TESTIMONIALS DISCLAIMER",
                },
              ]}
            />
          </Col>

          <Col
            className="detailedDisclaimer"
            ref={ansWrapperRef}
          >
            <div
              className="disclaimerSection"
              id="part-1"
            >
              <h2 className="sectionHeading">WEBSITE DISCLAIMER</h2>
              <p className="sectionContent">
                Alpha Capital Group Limited operates an educational and training platform for customers who want to learn how to trade effectively. All virtual trading activity carried out by our
                customers is simulated or virtual trading only. As we are not carrying out any regulated investment business and we are not issuing any financial promotions, we are not required to be
                authorised and regulated by the Financial Conduct Authority and our services will not be covered by the Financial Ombudsman Service. The information provided by Alpha Capital Group
                Limited ("we," "us," or "our") on http://www.alphacapitalgroup.uk (the "Site") is for general informational purposes only. All information on the Site is provided in good faith,
                however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any
                information on the Site. UNDER NO CIRCUMSTANCE SHALL WE HAVE ANY LIABILITY TO YOU FOR ANY LOSS OF DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE SITE OR RELIANCE ON ANY
                INFORMATION PROVIDED ON THE SITE. YOUR USE OF THE SITE AND YOUR RELIANCE ON ANY INFORMATION ON THE SITE IS SOLELY AT YOUR OWN RISK.
              </p>
            </div>
            <div
              className="disclaimerSection"
              id="part-2"
            >
              <h2 className="sectionHeading">EXTERNAL LINKS DISCLAIMER</h2>
              <p className="sectionContent">
                The Site may contain (or you may be sent through the Site) links to other websites or content belonging to or originating from third parties or links to websites and features in
                banners or other advertising. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us. WE DO
                NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR THE ACCURACY OR RELIABILITY OF ANY INFORMATION OFFERED BY THIRD-PARTY WEBSITES LINKED THROUGH THE SITE OR ANY WEBSITE OR
                FEATURE LINKED IN ANY BANNER OR OTHER ADVERTISING. WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY PROVIDERS OF
                PRODUCTS OR SERVICES.
              </p>
            </div>
            <div
              className="disclaimerSection"
              id="part-3"
            >
              <h2 className="sectionHeading">PROFESSIONAL DISCLAIMER</h2>
              <p className="sectionContent">
                Alpha Capital Group Limited does not carry out any regulated activities, the only exclusive activities we carry out are Proprietary Virtual trading and Professional Training.
                Consequently, we are not required to be authorized by the regulatory authority. Traders do not have direct access to company capital, and trade accounts with virtual funds, therefore,
                traders are not required to have a money managers license. Alpha Capital Group Limited & ACG Markets are not a broker, and do not accept deposits. All information provided on this site
                is intended solely for the study purposes related to virtual trading on financial markets and does not serve in any way as a specific investment recommendation, business
                recommendation, investment opportunity analysis or similar general recommendation regarding the virtual trading of investment instruments. Virtual trading in financial markets is a
                high-risk activity and it is advised not to risk more than one can afford to lose.
              </p>
            </div>
            <div
              className="disclaimerSection"
              id="part-4"
            >
              <h2 className="sectionHeading">TESTIMONIALS DISCLAIMER</h2>
              <p className="sectionContent">
                The Site may contain testimonials by users of our products and/or services. These testimonials reflect the real-life experiences and opinions of such users. However, the experiences
                are personal to those particular users, and may not necessarily be representative of all users of our products and/or services. We do not claim, and you should not assume, that all
                users will have the same experiences. YOUR INDIVIDUAL RESULTS MAY VARY.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Disclaimer;
